import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { IMG } from "../data";

export const Entrance = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const scale = useTransform(scrollYProgress, [0, 1], [1.15, 1.28]);
  const y = useTransform(scrollYProgress, [0, 1], ["-4%", "4%"]);

  return (
    <section id="ingresso" ref={ref} data-testid="entrance-section" className="relative h-[80vh] min-h-[560px] overflow-hidden bg-[#2b2620]">
      <motion.div style={{ scale, y }} className="absolute inset-0">
        <motion.img
          src={IMG.signage}
          alt="Gabriella Ritondo Holding — Leadership. Innovation. Impact."
          className="w-full h-full object-cover"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1.6, ease: [0.22, 1, 0.36, 1] }}
        />
      </motion.div>

      {/* subtle depth vignette */}
      <div className="absolute inset-0 pointer-events-none"
        style={{ boxShadow: "inset 0 0 180px 40px rgba(30,26,20,0.45)" }} />
      <div className="absolute inset-x-0 bottom-0 h-40 bg-gradient-to-t from-black/45 to-transparent pointer-events-none" />

      <div className="absolute bottom-0 left-0 right-0">
        <div className="max-w-7xl mx-auto px-6 sm:px-12 pb-10 flex flex-wrap items-end justify-between gap-4">
          <motion.div
            initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
            transition={{ duration: 0.9, delay: 0.6, ease: [0.22, 1, 0.36, 1] }}
            className="overline !text-[var(--gold)]">
            La sede · The Holding
          </motion.div>
          <motion.p
            initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
            transition={{ duration: 0.9, delay: 0.75, ease: [0.22, 1, 0.36, 1] }}
            className="text-white/80 text-sm max-w-sm">
            Un ecosistema che unisce consulenza, formazione, prodotti digitali e community.
          </motion.p>
        </div>
      </div>
    </section>
  );
};
